
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Component({ name: 'svg-icon' })
export default class indexView extends Vue {
  @Prop({ type: String, default: '' }) name!: string
  @Prop({ type: String, default: '' }) width!: string
  @Prop({ type: String, default: '' }) height!: string
  @Prop({ type: String, default: '14' }) size!: string

  style = {
    width: `${Number(this.width || this.size) / 100}rem`,
    height: `${Number(this.height || this.size) / 100}rem`,
    lineHeight: `${Number(this.height || this.size) / 100}rem`,
    display: 'inline-block',
  }

  get iconName() {
    return `#icon-${this.name}`
  }

  handleClick() {
    this.$emit('action')
  }
}
